<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">

    <div class="form-section">
      <app-form-row
        [label]="['FORMS.ARTICLE.MNR', 'FORMS.ARTICLE.EAN'] | translateControl : form | async">
        <div class="row">
          <div class="col-6">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'mnr'" datatestid="articleNumberInput">
            </app-input>
          </div>
          <div class="col-6">
            <app-input [type]="'text'" [mainForm]="form" [controlName]="'ean'" datatestid="eanInput">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.NAME' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'name'" datatestid="nameInput">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.DESCRIPTION' | translateControl : form | async">
        <app-textarea [mainForm]="form" [controlName]="'description'">
        </app-textarea>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.CATEGORY' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'category'" datatestid="categoryInput">
        </app-input>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.UNIT' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'unit'" datatestid="unitInput">
        </app-input>
      </app-form-row>

      <app-form-row *ngIf="isDealer else manufacturerPriceRow"
        [label]="['FORMS.ARTICLE.LIST_PRICE', 'FORMS.ARTICLE.PURCHASE_PRICE'] | translateControl : form | async">
        <div class="row">
          <div class="col-6">
            <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="form" [controlName]="'listPrice'" datatestid="listPriceInput">
            </app-input>
          </div>
          <div class="col-6">
            <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="form" [controlName]="'purchasePrice'" datatestid="purchasePriceInput">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <ng-template #manufacturerPriceRow>
        <app-form-row [label]="['FORMS.ARTICLE.LIST_PRICE'] | translateControl : form | async">
          <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="form" [controlName]="'listPrice'" datatestid="listPriceInput">
          </app-input>
        </app-form-row>
      </ng-template>

      <app-form-row
        [label]="['FORMS.ARTICLE.HEIGHT', 'FORMS.ARTICLE.WIDTH', 'FORMS.ARTICLE.DEPTH'] | translateControl : form | async">
        <div class="row">
          <div class="col-4">
            <app-input [type]="'number'" [suffix]="'mm'" [mainForm]="form" [controlName]="'height'">
            </app-input>
          </div>
          <div class="col-4">
            <app-input [type]="'number'" [suffix]="'mm'" [mainForm]="form" [controlName]="'width'">
            </app-input>
          </div>
          <div class="col-4">
            <app-input [type]="'number'" [suffix]="'mm'" [mainForm]="form" [controlName]="'depth'">
            </app-input>
          </div>
        </div>
      </app-form-row>

      <app-form-row [label]="'FORMS.ARTICLE.DIN' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'direction'" datatestid="directionInput">
        </app-input>
      </app-form-row>
    </div>

  </div>

</form>
